<ng-container *transloco="let t; read: 'accounts'">
<div class="p-5">
  <div class="mb-5 mr-3">
    <drdp-title [title]="t('loginAudits.title')"></drdp-title>
  </div>
  <drdp-container [additionClasses]="'min-h-[44rem]'">
    <drdp-container color="lightBlue" additionClasses="min-h-[7rem] w-full">
      <form [formGroup]="searchForm"
        class="flex grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 p-3 gap-2 md:gap-2 flex-row content-center my-auto justify-center">

        <div class="col-span-full md:col-span-1">
          <mat-form-field appearance="fill">
            <label class="global-font-bold required" for="StartDate">{{ t('loginAudits.startDate') }}</label>
            <input matInput autocomplete="off" name="minDatePicker" [matDatepicker]="minPicker"
              formControlName="fromDate" [attr.aria-label]="t('loginAudits.startDate')" (dateChange)="resetEndDate()" [placeholder]="'shared.datePicker.placeholder' | transloco">
              <mat-datepicker-toggle matSuffix [for]="minPicker"></mat-datepicker-toggle>
              <mat-datepicker #minPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-span-full md:col-span-1">
            <mat-form-field appearance="fill">
              <label class="global-font-bold required" for="EndDate">{{ t('loginAudits.endDate') }}</label>
              <input matInput autocomplete="off" name="maxDatePicker" [attr.aria-label]="t('loginAudits.endDate')" [matDatepicker]="maxPicker"
                formControlName="toDate" [placeholder]="'shared.datePicker.placeholder' | transloco">
                <mat-datepicker-toggle matSuffix [for]="maxPicker"></mat-datepicker-toggle>
                <mat-datepicker #maxPicker></mat-datepicker>
                @if (searchForm.controls['toDate'].errors?.['invalidDates']) {
                  <mat-error></mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-span-1">
              <drdp-select-role [label]="t('common.role')" [multiSelect]="true" [clear]="clearDropdown" (role)="handleRoles($event)" [required]="true">
              </drdp-select-role>
            </div>

            <div
              class="flex lg:flex-row md:flex-wrap lg:col-span-2 justify-evenly xl:justify-evenly lg:justify-center md:content-end lg:content-center mt-3 lg:mt-0 xl:mt-9">
            <drdp-btn [additionalClasses]="'lg:m-2 xl:m-0'" [disabled]="!searchForm.valid" (click)="submitSearch()">
              <span>{{ t('common.search') }}</span>
            </drdp-btn>
            <drdp-btn color="outline" [additionalClasses]="'lg:m-2 xl:m-0'" (click)="download()"
              [disabled]="!searchForm.valid">
              {{ t('common.download') }} <i class="uil uil-download-alt"></i>
            </drdp-btn>
            <drdp-btn type="button" [additionalClasses]="'lg:m-2 xl:m-0'" color="outline" (click)="clear()">
              {{ t('common.clear') }}
            </drdp-btn>
          </div>
        </form>
        @if (searchForm.controls['toDate'].touched && (searchForm.controls['toDate'].errors?.['invalidDates'] || searchForm.controls['toDate'].errors?.['dateRangeNotWithinOneYear'])) {
          <span
            class="text-sm text-red-700">
            {{ t('loginAudits.dateRangeError') }}
          </span>
        }
      </drdp-container>
      <drdp-add-edit-table [dataSource]="dataSource" [noDataMessage]="t('loginAudits.noRecords')"
        [tableData]="tableData" [columns]="tableColumns">
      </drdp-add-edit-table>
    </drdp-container>
    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [length]="totalData" [pageIndex]="pageIndex"
      (page)="paginateAgency()">
    </mat-paginator>
</div>
</ng-container>